var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('Widget',[_c('CustomerDetails',{attrs:{"customer":_vm.customer}})],1)],1),_c('v-col',{attrs:{"cols":"6"}},[_c('Widget',{attrs:{"title":"Actions"}},[_c('CustomerActions',{ref:"customerActions",attrs:{"customer":_vm.customer}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }